<template>
  <el-dialog :title="getTitle" top="10px" :visible.sync="dailogShow" width="95%" :close-on-click-modal="false" :before-close="handleClose" @open="handleOpen">
    <el-row :gutter="10" style="margin-bottom: 10px">
      <el-col :span="12">
        <div style="float:right">
          <span>{{ getEmpty }}</span>
          <el-button v-if="taskIsCanEdit" size="small" type="primary" style="float:left" @click="handleEdit">编 辑</el-button>
          <el-button v-if="postForm.isFangAnEdit" size="small" type="primary" style="float:left" @click="handleDinggao">定 稿</el-button>
          <!-- <el-button v-if="taskIsCanDel" size="small" type="danger" style="float:left" @click="handleDel">删 除</el-button> -->
        </div>
      </el-col>
      <el-col :span="12">
        <div style="float:right">
          <el-button size="small" type="primary" @click="handleFollow">跟进</el-button>
          <el-button size="small" type="primary" @click="handleFollow">跟进并提醒</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-descriptions :label-style="getDescLabelStyle" class="margin-top" :column="2" border>
          <el-descriptions-item label="任务名称">{{ postForm.workTaskName }} </el-descriptions-item>
          <el-descriptions-item label="提交父审"><span v-if="postForm.isAuditByParent">☑</span><span v-else>☐</span></el-descriptions-item>
          <el-descriptions-item label="负责人"><el-tag>{{ getMemberName(postForm.leaderId) }}</el-tag></el-descriptions-item>
          <el-descriptions-item label="方案状态">{{ getDictName(postForm.fangAnStatusDictKey) }}</el-descriptions-item>
          <el-descriptions-item :span="2" label="任务期间">{{ datetimeFormat(postForm.beginDate) }} ~ {{ datetimeFormat(postForm.endDate) }}</el-descriptions-item>
          <el-descriptions-item :span="2" label="任务描述"><span v-html="getTextAreaContent(postForm.workTaskDescribe)" /></el-descriptions-item>
        </el-descriptions>
        <el-form label-width="85px" class="demo-ruleForm" label-position="right">
          <el-form-item label="任务附件">
            <WorkTaskFile
              v-model="fileList"
              :is-can-edit="false"
              :module-code="moduleCode"
              :module-key="moduleKey"
              :task-id="entityId"
              file-type="D9601"
            />
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span="12">
        <el-form ref="followForm" :model="followForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-position="right">
          <el-form-item label="跟进描述" prop="followContent">
            <el-input v-model="followForm.followContent" :rows="5" type="textarea" />
          </el-form-item>
          <el-form-item label="跟进附件">
            <WorkTaskFile
              v-model="fileListFol"
              :is-can-edit="true"
              :module-code="moduleCode"
              :module-key="moduleKey"
              :task-id="entityId"
              file-type="D9602"
            />
          </el-form-item>
          <el-form-item label="任务状态">
            <el-radio-group v-model="followForm.workTaskStatusDictKey" size="small" :disabled="postForm.auditingType>0 || postForm.fangAnStatusDictKey==='D9401'">
              <el-radio-button v-for="(item,idx) in getComboxData('D91')" :key="idx" :label="item.value">{{ item.label }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="postForm.auditingType">
            <span>{{ getDictName(postForm.workTaskStatusDictKey) }}
              <span v-if="postForm.auditingType">(审核中)</span></span>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <WorkTaskExtra
          ref="formExtra"
          :entity-id="entityId"
          :module-code="moduleCode"
          :module-key="moduleKey"
          :task-member-list="memberList"
        />
      </el-col>

    </el-row>
    <div class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
      <el-button type="primary" @click="handleFollow()">跟 进</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
// import Combox from '@/views/managesystem/gz/com/Combox'
import KxjCom from '@/utils/kxjcom'
import WorkTaskExtra from './WorkTaskExtra'
import WorkTaskFile from './WorkTaskFile'
import { getTextAreaContent } from '@/utils/index'
// import WorkTaskDiscuss from './WorkTaskDiscuss.vue'
export default {
  components: {
    WorkTaskExtra, WorkTaskFile
  },
  props: {
    entityId: { type: Number, default: null },
    moduleCode: { type: String, default: '' },
    moduleKey: { type: Number, default: null }
  },
  data() {
    return {
      dailogShow: false,
      allComboxData: [],
      postForm: {},
      parentTitle: [],
      memberList: [],
      activeName: 'second',
      disContent: '',
      disList: [],
      operLogList: [],
      timelineList: [],
      getDescLabelStyle: {
        width: '80px',
        'text-align': 'right'
      },
      taskIsCanEdit: false,
      taskIsCanDel: false,
      followForm: {
        followContent: '',
        workTaskStatusDictKey: ''
      },
      rules: {
        followContent2: [
          { required: true, message: '请输入跟进描述', trigger: 'change,blur' }
        ]
      },
      checkInfo: {},
      allTempFiles: [],
      fileList: [], // 任务附件
      fileListFol: [] // 跟进附件
    }
  },
  /** 计算 */
  computed: {
    isEdit() {
      return !!this.entityId
    },
    getTitle() {
      var ret = '课题/任务: '
      if (this.parentTitle && this.parentTitle.length > 0) {
        ret += this.parentTitle.join('/')
      } else {
        ret += '任务详情'
      }
      return ret
    },
    getEmpty() {
      return '　'
    }

  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    pathReq.getComboxDatasByIdArray('D86;D87;D91;D94').then(res => {
      that.allComboxData = res.data.result
    })
  },
  mounted() {
    // if (this.timer) {
    //   clearInterval(this.timer)
    // } else {
    //   this.timer = setInterval(() => {
    //     this.handleReflashDisList()
    //   }, 10000)
    // }
  },
  beforeDestroy() {
    // debugger
    // if (this.timer) {
    //   clearInterval(this.timer)
    // }
  },
  methods: {
    getTextAreaContent,
    dateFormat: KxjCom.tableDateFormat,
    datetimeFormat: KxjCom.tableDateTimeFormat,
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter((item) => {
        return item.typeId === typeId
      })
    },
    getDictName(key) {
      var l = this.allComboxData.filter((item) => {
        if (item.value === key) {
          return item
        }
      })
      if (l.length > 0) {
        return l[0].label
      } else {
        return ''
      }
    },
    getMemberName(key) {
      var l = this.memberList.filter((item) => {
        if (item.id === key) {
          return item
        }
      })
      if (l.length > 0) {
        return l[0].userName
      } else {
        return ''
      }
    },

    show(tabName) {
      this.dailogShow = true
      if (tabName) {
        this.$refs.formExtra.selTab(tabName)
      }
    },
    handleClose() {
      // debugger
      // if (this.timer) {
      //   clearInterval(this.timer)
      // }

      this.$refs['followForm'].resetFields()
      this.postForm = {}
      this.disContent = ''
      this.$refs.formExtra.clearData()
      this.dailogShow = false
    },
    handleOpen() {
      const that = this
      let path = '/api/services/app/WorkTask/GetEditWorkTask'
      path += '?ModuleCode=' + this.moduleCode
      path += '&ModuleKey=' + this.moduleKey

      if (this.entityId) {
        path += '&Id=' + this.entityId
      }

      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getNoParams(path).then(res => {
        that.postForm = res.data.result.entityData
        that.parentTitle = res.data.result.parentTitle
        that.checkInfo = res.data.result.check01
        that.followForm.workTaskStatusDictKey = that.postForm.workTaskStatusCurrentDictKey
        that.memberList = res.data.result.memberList
        that.taskIsCanEdit = res.data.result.isCanEdit
        that.taskIsCanDel = res.data.result.isCanDel
        that.allTempFiles = res.data.result.workTaskFiles
        that.fileList = that.allTempFiles.filter(x => x.filetype === 'D9601')
        that.fileListFol = []
        // 日期范围赋值
        if (this.postForm.id) {
          if (that.postForm.beginDate && that.postForm.endDate) {
            // that.postForm.beginendDateArr
            var dateRange = [
              that.postForm.beginDate.substr(0, 10),
              that.postForm.endDate.substr(0, 10)
            ]
            that.$set(that.postForm, 'beginendDateArr', dateRange)
          }
        }
      }).then(_ => {
        loading.close()
      }).then(_ => {
        that.$refs.formExtra.init()
      })
    },
    /** 跟进 */
    handleFollow() {
      this.$refs['followForm'].validate(valid => {
        if (valid) {
          const that = this
          var path = ''

          const postForm = {
            taskId: that.entityId,
            workTaskStatusDictKey: that.followForm.workTaskStatusDictKey,
            followContent: that.followForm.followContent,
            tempFiles: that.fileListFol
          }
          path = '/api/services/app/WorkTask/DoCheck'
          pathReq.dataUpdate(path, that.checkInfo).then(r => {
            if (!r.data.result) {
              that.$message.error('任务内容或跟进信息有更新,请重新确认后再跟进')
              that.handleOpen()
              that.$refs.formExtra.init()
              return
            } else {
              path = '/api/services/app/WorkTask/DoFollow'
              pathReq.dataUpdate(path, postForm).then(res => {
                that.$message.success('保存成功')
                this.$refs['followForm'].resetFields()
                this.$refs.formExtra.clearData()
                this.$emit('save-success')
              }).then(_ => {
                this.dailogShow = false
              })
            }
          })
        }
      })
    },
    /** 日期变化 */
    handleDateChange() {
      if (this.postForm.beginendDateArr.length > 0) {
        this.postForm.beginDate = this.postForm.beginendDateArr[0]
        this.postForm.endDate = this.postForm.beginendDateArr[1]
      } else {
        this.postForm.beginDate = null
        this.postForm.endDate = null
      }
    },

    handleEdit() {
      this.$emit('ToEdit', this.entityId)
      this.$refs.formExtra.clearData()
      this.dailogShow = false
    },
    handleDel() {
      const that = this
      this.$confirm('确定要删除该任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/WorkTask/DeleteWorkTask'
        pathReq.dataDelete(path, that.entityId).then(res => {
          this.$message.success('删除成功!')
          this.$refs.formExtra.clearData()
          that.dailogShow = false
          that.$emit('save-success')
        })
      }).catch(() => {
      })
    },
    handleDinggao() {
      const that = this
      var path = ''
      this.$confirm('确定要将该任务设置成定稿吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const load = that.$loading(KxjCom.loadOptions)
        path = '/api/services/app/WorkTask/DoCheck'
        pathReq.dataUpdate(path, that.checkInfo).then(r => {
          if (!r.data.result) {
            that.$message.error('任务内容或跟进信息有更新,请重新确认后再定稿')
            that.handleOpen()
            that.$refs.formExtra.init()
            return
          } else {
            path = '/api/services/app/WorkTask/DoDinggao'
            pathReq.dataUpdate(path, { id: that.entityId }).then(res => {
              that.$message.success('该任务已定稿!')
              that.handleOpen()
            })
          }
        }).then(() => {
          load.close()
        })
      })
    },
    handleDisSuccess() {
      this.$refs.formExtra.activeName = 'tab01'
      this.$refs.formExtra.handleReflashDisList()
    }

  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
.descLabel{
  width: 100px !important;
}
</style>
